const urlPrefix = __URLPREFIX__;

export default function urlMiddleware(history) {
  return ({dispatch, getState}) => {
    return next => action => {

      const result = next(action);

      const { url, ...rest } = action;
      if (url) {
        if (typeof url === 'function') {
          history.push(urlPrefix + url(getState()));
        }
        else {
          history.push(urlPrefix + url);
        }
      }
      return result;
    };
  };
}



// WEBPACK FOOTER //
// ./src/redux/middleware/urlMiddleware.js